import { Study } from 'interfaces/study';

type StudyActionStudy =
  | Pick<
      Study,
      | 'id'
      | 'slidesCount'
      | 'casesCount'
      | 'hasFeatures'
      | 'hasResults'
      | 'hasUnpublishedFeatures'
      | 'hasUnpublishedCellTables'
      | 'hasInternallyApprovedFeatures'
      | 'hasInternallyApprovedCellTables'
    >
  | null
  | undefined;

export const studyHasUploadedSlides = (study: StudyActionStudy) =>
  Boolean(study && ((study.slidesCount ?? 0) > 0 || (study.casesCount ?? 0) > 0));

// Published, internally approved, and unpublished flags all mean post-processing produced something
// this user may be able to export. An absent flag is not evidence of results.
export const studyHasPostProcessingResults = (study: StudyActionStudy) =>
  Boolean(
    study &&
      (study.hasFeatures ||
        study.hasResults ||
        study.hasUnpublishedFeatures ||
        study.hasUnpublishedCellTables ||
        study.hasInternallyApprovedFeatures ||
        study.hasInternallyApprovedCellTables)
  );

export const shouldShowStudyExport = (study: StudyActionStudy) =>
  Boolean(study?.id) && (studyHasUploadedSlides(study) || studyHasPostProcessingResults(study));

export const shouldShowPrepareCustomerResults = (study: StudyActionStudy) =>
  Boolean(study?.id) && studyHasPostProcessingResults(study);
